export default "__VITE_ASSET__DrsXGXqS__"